module.exports = __webpack_public_path__ + "static/media/csm-plus.73e5a0b4.svg";